/* eslint-disable @typescript-eslint/naming-convention */
export const APP_CONSTANTS = {
  API_CLAVES_CIAS_NAME: 'api-claves-cias'
};
